// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {ForwardedRef, ReactNode, forwardRef} from 'react';
import {useTranslation, Trans as T} from 'react-i18next';
import cn from 'classnames';
// @ts-ignore
import {url2md5} from 'pub_config';
import styles from './media_block.module.less';

interface i_cls_obj {
    container?: string;
    content?: string;
    title?: string;
    text?: string;
    img?: string;
}
export interface i_media_block_props {
    img?: string;
    title?: string;
    text?: string;
    img_content?: JSX.Element;
    text_content?: JSX.Element;
    cls?: i_cls_obj;
    reversed?: boolean;
    components?: object_of<JSX.Element>;
    children?: ReactNode;
}
export const Media_block = forwardRef(
    (props:i_media_block_props, ref?: ForwardedRef<HTMLDivElement>)=>{
    const {img, title, text, img_content, text_content, cls = {},
        reversed, components, children} = props;
    useTranslation();
    const container_cls = cn(styles.media_block, cls.container,
        reversed && styles.reversed);
    return <div className={container_cls} ref={ref}>
      {text_content ? text_content : <div
        className={cn(styles.text, cls.content)}>
        <h3 className={cls.title}><T i18nKey={title} components={components}/>
        </h3>
        <p className={cls.text}><T i18nKey={text} components={components}/></p>
        {children}
      </div>}
      {img_content ? img_content : <div
        className={cn(styles.img, cls.img)}>
        <img src={url2md5(`/www/hola/pub/img/${img}`)} alt="media_image"
          className="lazyload"/>
      </div>}
    </div>;
});
